import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib//helpers/api';
import { types, actions } from './reducer';
import TypeService from '@iso/services/SettingsService/ProductService/TypeService';

function* deleteType({ id }) {
    try {
        yield call(TypeService.deleteOne, id);
        yield put(actions.deleteTypeSucceeded(id));
    } catch (error) {
        yield put(actions.deleteTypeFailed(extractError(error)));
    }
}

function* watchDeleteType() {
    yield takeEvery(
        types.REQUEST_DELETE_TYPE,
        deleteType,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteType),
    ]);
}

export default deleteSaga;
